import { GenericHeader, SearchBar } from 'components';
import ListComp from 'components/ListComp';
import React from 'react';
import { Module } from 'services';
import { Results, CreateModal } from './components';
import { curriculum_manager } from 'utils/constants';
import { Button } from '@material-ui/core';
const ModuleList = props => {
  let { mastery } = props;
  const Head = props => {
    let { handleCreateOpen, ...rest } = props; // eslint-disable-line
    if (mastery) return (
      <GenericHeader subheader={`Modules for ${mastery.name_en}`} >
        <Button color="primary" onClick={handleCreateOpen} variant="contained">
          Add Module
        </Button>
      </GenericHeader>
    );
    return (
      <GenericHeader header="All Modules" subheader="Modules Management" {...rest} />
    );
  }

  return (
    <ListComp
      listing={Module.list}
      title="Modules"
      name="modules"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      CreateComp={CreateModal}
      Results={Results}
      roles={[curriculum_manager]}
      filters={{ limit: 10, offset: 0, count: 0, search: "", mastery_level: mastery ? mastery.id : null }}
      comp_props={{ create_comp: { mastery_level_id: mastery ? mastery.id : null } }}
    />
  );
};

export default ModuleList;
